// extracted by mini-css-extract-plugin
export default {"emojiBox":"Emoji_emojiBox__KWOvX"};